import { useMutation } from '@tanstack/react-query';
import { postWallet } from '../walletsService';

interface usePostWalletVariables {
  wallet: string;
  label: string;
  primary: boolean;
}

export const usePostWallet = () => {
  return useMutation({
    mutationFn: async ({ wallet, label, primary }: usePostWalletVariables) => postWallet(wallet, primary, label),
  });
};
